var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0472 17.2978V9.80305H0.358398V6.8248H3.0472V4.4782C3.0472 1.92868 4.71587 0.541016 7.15227 0.541016C8.31964 0.541016 9.32224 0.622836 9.61321 0.658837V3.3229H7.9235C6.59838 3.3229 6.34247 3.912 6.34247 4.77275V6.8248H9.33276L8.9226 9.80305H6.34247V17.2978",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_2177",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0472 17.2978V9.80305H0.358398V6.8248H3.0472V4.4782C3.0472 1.92868 4.71587 0.541016 7.15227 0.541016C8.31964 0.541016 9.32224 0.622836 9.61321 0.658837V3.3229H7.9235C6.59838 3.3229 6.34247 3.912 6.34247 4.77275V6.8248H9.33276L8.9226 9.80305H6.34247V17.2978",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_2177)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookB);
export default __webpack_public_path__ + "static/media/facebookB.0550af71903d50769859981ca4338001.svg";
export { ForwardRef as ReactComponent };